import { TRACKPAD_PIXEL_THRESHOLD_PX, WHEEL_OVERRIDE_THRESHOLD_PX } from './scrollControl.constants';

export type WheelInputKind = 'trackpad' | 'wheel';

export interface WheelSignal {
  /** `WheelEvent.deltaMode`: 0 = pixels, 1 = lines, 2 = pages. */
  deltaMode: number;
  maxDeltaInPx: number;
  hasFractionalDelta: boolean;
}

// The browser does not say which device sent the event, so read the signature: trackpads emit
// small, often fractional pixel deltas; wheels emit larger, mostly integer or line/page ones.
// Sticky per gesture — re-deciding per event changes speed mid-flick.
export const resolveWheelInputKind = (
  current: WheelInputKind | null,
  { deltaMode, maxDeltaInPx, hasFractionalDelta }: WheelSignal,
): WheelInputKind => {
  if (!current) {
    const isLikelyTrackpad = deltaMode === 0 && (hasFractionalDelta || maxDeltaInPx < TRACKPAD_PIXEL_THRESHOLD_PX);
    return isLikelyTrackpad ? 'trackpad' : 'wheel';
  }

  if (current === 'trackpad' && (deltaMode !== 0 || maxDeltaInPx > WHEEL_OVERRIDE_THRESHOLD_PX)) {
    return 'wheel';
  }

  if (current === 'wheel' && deltaMode === 0 && hasFractionalDelta && maxDeltaInPx < TRACKPAD_PIXEL_THRESHOLD_PX) {
    return 'trackpad';
  }

  return current;
};
